import { Flex, PageWrapper, Spacing } from '@approvalmax/ui/src/components';
import { memo } from 'react';
import Skeleton from 'react-loading-skeleton';

export const Loading = memo(() => {
    return (
        <PageWrapper>
            <PageWrapper.Toolbar bordered spacingBottom={0}>
                <Flex justifyContent='space-between'>
                    <Skeleton width={180} height={28} />

                    <Skeleton width={180} height={28} />
                </Flex>

                <Spacing height={12} />
            </PageWrapper.Toolbar>

            <PageWrapper.Content>
                <Skeleton width={200} height={26} />

                <Spacing height={24} />

                <Skeleton height={100} />
            </PageWrapper.Content>
        </PageWrapper>
    );
});
